import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Measurement of the complete system",
  layout: {
    type: "customCase040106",
    options: {
      views: {
        frequency: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide06-frequency.svg`,
        },
        impulse: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide06-impulse.svg`,
        },
        directivity: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide06-directivity.svg`,
        },
        mcq: {
          task: {
            correctAnswer: 1,
          },
        },
      },
    },
  },
};

export default principle;
